import { Module } from 'vuex'

function initialState() {
  return {
    // Display
    brandName: 'askbet',
    showContextWithBrandName: true,

    showErrors: true,
    showMultipleErrors: false,
    showErrorCode: false,
    showErrorParameters: false,
    hideSuggestions: false,
    showBetSlipListItem: false,
    showBetSlipSidebar: false,
    showBetBuilderSelectionPrices: false,

    // Voice
    speakerId: '',
    voiceEngines: '',
    language: '',

    // Logging
    sendLogsToServer: false,
    showLogLogs: false,
    showInfoLogs: false,
    showWarnLogs: false,
    showErrorLogs: false,
    showLogGroups: false,
    showTimers: false,
    showPerformanceLogs: false,

    // Experimental
    resumeAudioContext: true,
  }
}

const settingsModule: Module<any, any> = {
  namespaced: true,

  state: initialState,

  mutations: {
    resetSettingsStore(state) {
      const initial: any = initialState()
      Object.keys(initial).forEach((key) => {
        if (key in state) {
          state[key] = initial[key]
        }
      })
    },

    // Display

    setBrandName(state, brandName) {
      state.brandName = brandName
    },

    setShowContextWithBrandName(state, showContextWithBrandName) {
      state.showContextWithBrandName = showContextWithBrandName
    },

    setShowErrors(state, showErrors) {
      state.showErrors = showErrors
    },

    setShowMultipleErrors(state, showMultipleErrors) {
      state.showMultipleErrors = showMultipleErrors
    },

    setShowErrorCode(state, showErrorCode) {
      state.showErrorCode = showErrorCode
    },

    setShowErrorParameters(state, showErrorParameters) {
      state.showErrorParameters = showErrorParameters
    },

    setHideSuggestions(state, hideSuggestions) {
      state.hideSuggestions = hideSuggestions
    },

    setShowBetSlipListItem(state, showBetSlipListItem) {
      state.showBetSlipListItem = showBetSlipListItem
    },

    setShowBetSlipSidebar(state, showBetSlipSidebar) {
      state.showBetSlipSidebar = showBetSlipSidebar
    },

    setShowBetBuilderSelectionPrices(state, showBetBuilderSelectionPrices) {
      state.showBetBuilderSelectionPrices = showBetBuilderSelectionPrices
    },

    // Voice

    setSpeakerId(state, speakerId) {
      state.speakerId = speakerId
    },

    setVoiceEngines(state, voiceEngines) {
      state.voiceEngines = voiceEngines
    },

    setLanguage(state, language) {
      state.language = language
    },

    // Logging

    setSendLogsToServer(state, sendLogsToServer) {
      state.sendLogsToServer = sendLogsToServer
    },

    setShowLogLogs(state, showLogLogs) {
      state.showLogLogs = showLogLogs
    },

    setShowInfoLogs(state, showInfoLogs) {
      state.showInfoLogs = showInfoLogs
    },

    setShowWarnLogs(state, showWarnLogs) {
      state.showWarnLogs = showWarnLogs
    },

    setShowErrorLogs(state, showErrorLogs) {
      state.showErrorLogs = showErrorLogs
    },

    setShowLogGroups(state, showLogGroups) {
      state.showLogGroups = showLogGroups
    },

    setShowTimers(state, showTimers) {
      state.showTimers = showTimers
    },

    setShowPerformanceLogs(state, showPerformanceLogs) {
      state.showPerformanceLogs = showPerformanceLogs
    },

    // Experimental

    setResumeAudioContext(state, resumeAudioContext) {
      state.resumeAudioContext = resumeAudioContext
    },
  },

  actions: {
    resetSettingsStore({ commit }) {
      commit('resetSettingsStore')
    },

    setBrandName({ commit }, brandName) {
      commit('setBrandName', brandName)
    },

    setShowContextWithBrandName({ commit }, showContextWithBrandName) {
      commit('setShowContextWithBrandName', showContextWithBrandName)
    },

    setShowErrors({ commit }, showErrors) {
      commit('setShowErrors', showErrors)
    },

    setShowMultipleErrors({ commit }, showMultipleErrors) {
      commit('setShowMultipleErrors', showMultipleErrors)
    },

    setShowErrorCode({ commit }, showErrorCode) {
      commit('setShowErrorCode', showErrorCode)
    },

    setShowErrorParameters({ commit }, showErrorParameters) {
      commit('setShowErrorParameters', showErrorParameters)
    },

    setHideSuggestions({ commit }, hideSuggestions) {
      commit('setHideSuggestions', hideSuggestions)
    },

    setShowBetSlipListItem({ commit }, showBetSlipListItem) {
      commit('setShowBetSlipListItem', showBetSlipListItem)
    },

    setShowBetSlipSidebar({ commit }, showBetSlipSidebar) {
      commit('setShowBetSlipSidebar', showBetSlipSidebar)
    },

    setShowBetBuilderSelectionPrices(
      { commit },
      showBetBuilderSelectionPrices,
    ) {
      commit('setShowBetBuilderSelectionPrices', showBetBuilderSelectionPrices)
    },

    // Voice

    setSpeakerId({ commit }, speakerId) {
      commit('setSpeakerId', speakerId)
    },

    setVoiceEngines({ commit }, voiceEngines) {
      commit('setVoiceEngines', voiceEngines)
    },

    setLanguage({ commit }, language) {
      commit('setLanguage', language)
    },

    // Logging

    setSendLogsToServer({ commit }, sendLogsToServer) {
      commit('setSendLogsToServer', sendLogsToServer)
    },

    setShowLogLogs({ commit }, showLogLogs) {
      commit('setShowLogLogs', showLogLogs)
    },

    setShowInfoLogs({ commit }, showInfoLogs) {
      commit('setShowInfoLogs', showInfoLogs)
    },

    setShowWarnLogs({ commit }, showWarnLogs) {
      commit('setShowWarnLogs', showWarnLogs)
    },

    setShowErrorLogs({ commit }, showErrorLogs) {
      commit('setShowErrorLogs', showErrorLogs)
    },

    setShowLogGroups({ commit }, showLogGroups) {
      commit('setShowLogGroups', showLogGroups)
    },

    setShowTimers({ commit }, showTimers) {
      commit('setShowTimers', showTimers)
    },

    setShowPerformanceLogs({ commit }, showPerformanceLogs) {
      commit('setShowPerformanceLogs', showPerformanceLogs)
    },

    // Experimental

    setResumeAudioContext({ commit }, resumeAudioContext) {
      commit('setResumeAudioContext', resumeAudioContext)
    },
  },

  getters: {
    brandName(state) {
      return state.brandName
    },

    showContextWithBrandName(state) {
      return state.showContextWithBrandName
    },

    showErrors(state) {
      return state.showErrors
    },

    showMultipleErrors(state) {
      return state.showMultipleErrors
    },

    showErrorCode(state) {
      return state.showErrorCode
    },

    showErrorParameters(state) {
      return state.showErrorParameters
    },

    hideSuggestions(state) {
      return state.hideSuggestions
    },

    showBetSlipListItem(state) {
      return state.showBetSlipListItem
    },

    showBetSlipSidebar(state) {
      return state.showBetSlipSidebar
    },

    showBetBuilderSelectionPrices(state) {
      return state.showBetBuilderSelectionPrices
    },

    // Voice

    speakerId(state) {
      return state.speakerId
    },

    voiceEngines(state) {
      return state.voiceEngines
    },

    language(state) {
      return state.language
    },

    // Logging

    sendLogsToServer(state) {
      return state.sendLogsToServer
    },

    showLogLogs(state) {
      return state.showLogLogs
    },

    showInfoLogs(state) {
      return state.showInfoLogs
    },

    showWarnLogs(state) {
      return state.showWarnLogs
    },

    showErrorLogs(state) {
      return state.showErrorLogs
    },

    showLogGroups(state) {
      return state.showLogGroups
    },

    showTimers(state) {
      return state.showTimers
    },

    showPerformanceLogs(state) {
      return state.showPerformanceLogs
    },

    // Experimental

    resumeAudioContext(state) {
      return state.resumeAudioContext
    },
  },
}

export default settingsModule
